import SettingIcon from '../../image/icons/floating/SettingIcon.svg';

interface SettingsFloatingActionsProps {
  text: string;
  onClick: () => void;
}

const SettingsFloatingActions: React.FC<SettingsFloatingActionsProps> = ({ text, onClick }) => {
  return (
    <div className="flex bg-red">
      <div
        className="m-2 mb-1 mr-3 ml-auto cursor-pointer"
        onClick={onClick} // Trigger the function passed as a prop
      >
        <img src={SettingIcon} className="w-[40px] shadow-xl rounded-full" alt="Settings" />
      </div>
    </div>
  );
};

export default SettingsFloatingActions;
